"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Button = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  margin: theme.spacing(6, 3),
  [theme.breakpoints.up('sm')]: {
    margin: theme.spacing(6, 4)
  },
  [theme.breakpoints.up('lg')]: {
    margin: theme.spacing(6)
  }
}));
const Button = exports.Button = (0, _mui.styled)(_components.Button)({
  display: 'block',
  margin: '0 auto'
});
